<template>
  <div id="preview" class="tickets">
    <div class="printTitle"><span>{{range.start}} </span><span v-if="range.start!==range.end">~</span><span v-if="range.start!==range.end"> {{ range.end }}</span> 外帶預約列表</div>
    <div class="printCount">
      <div></div>
      <div>總人數: {{reduce(rows.map(e => (e.reserveNum||0)+(e.reserveNumChild||0)))}}</div>
      <div>導遊需求: {{reduce(rows.filter(e => (e.guideNeed||0)).map(e => reduce(e.Orders.filter(o => /導覽/ig.test(o.name)).map(e => e.count))))}}</div>
      <div></div>
    </div>
    <div class="each" v-for="(row, r) in rows" :key="r">
      <div :style="{}">{{row.status}}</div>
      <div :style="{alignItems:'start'}">
        <div :style="{whiteSpace:'nowrap'}">{{toDate(row.visitDate).slice(2, 10)}}</div>
        <div :style="{fontWeight:700}">{{row.visitTime}}</div>
      </div>
      <div>
        <div>{{row.agencyID}}</div>
        <div>{{row.agencyName}}</div>
      </div>
      <div>
        <div v-if="row.project">專案: {{row.project}}</div>
        <div >預約人: {{row.orderer}}</div>
        <div >電話: {{row.ordererTel||row.member?.name||row.recipientTel||'-'}}</div>
        <hr>
        <div >領隊: {{row.recipient}}</div>
        <div >電話: {{row.recipientTel||'-'}}</div>
      </div>
      <div :style="{alignItems:'center'}">
        <div :style="{whiteSpace:'nowrap'}">業務</div>
        <div :style="{whiteSpace:''}">{{row.salesman?.name.slice(0, 4)||'-'}}</div>
      </div>
      <div :style="{alignItems:'center'}">
        <template  v-if="!row.guideNeed">
        <div :style="{whiteSpace:'nowrap'}">導覽</div>
        <div :style="{whiteSpace:'nowrap'}">{{row.guideNeed===null?'待確認':'不需要'}}</div>
        </template>
        <template v-else>
        <div :style="{whiteSpace:'nowrap'}">導覽 <span :style="{fontSize: '20px', fontWeight: 700}">{{reduce(row.Orders.filter(o => /導覽/ig.test(o.name)).map(e => e.count))}}</span> 名</div>
        <div v-for="(rx, x) in row.Orders.filter(o => /導覽/ig.test(o.name))" :key="`x-${x}`">
          {{rx.items[0].opt.join(' ')}}</div>
        </template>

      </div>
      <div>
        <div :style="{whiteSpace:'nowrap', fontWeight:700}">總人數: {{(row.reserveNum||0)+(row.reserveNumChild||0)}}人</div>
        <div v-for="(rx, x) in row.Orders.filter(o => !/導覽/ig.test(o.name))" :key="`x-${x}`">
          {{rx.name?.slice(0, 6)}} * {{rx.count}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['rows', 'range']

}
</script>

<style lang="scss">
.printTitle {
  text-align: center;
  font-size: 18px;
  letter-spacing: 2px;
}
.printCount {
  border: 1px solid #CACACA;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  margin-top: 16px;
}
.printCount>div{
  flex:1;
  text-align: center;
}
.tickets {
  .each {
    display: grid;
    grid-template-columns: 2em 1fr 3fr 3fr 1.5fr 2fr 2fr;
    border: 1px solid #CACACA;
    margin-top: 10px;
    min-height: 85px;
    page-break-inside: avoid;
  }
  .each>div:not(:last-child) {
    border-right: 1px solid #CACACA;
  }
  .each>div {
    flex:1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    text-align: start;
    padding: 1em 10px;
    font-size: smaller;
  }
  .each>div>hr {
    width: 100%;
    height: 1px;
    background: #CACACA;
    margin: 1em 0;
    border: none;
  }
}
</style>
